// extracted by mini-css-extract-plugin
export var csatScore = "_o6-5";
export var header = "_o6-1";
export var panelWrapper = "_o6-2";
export var postPreview = "_o6-3";
export var rightContent = "_o6-0";
export var wrappingText = "_o6-4";